import { FirstRunView } from '@/features/onboarding';
import { useViewer } from '@/features/session';

export function GetStartedPage() {
  const { workspace } = useViewer();
  return workspace ? <FirstRunView workspace={workspace} /> : null;
}
